import { datadogRum } from '@datadog/browser-rum';
import React, { useContext } from 'react';
import { useLocation } from 'react-router';
import { CheckItOutContext, useSlate } from '|/context';
import useMfeModule from '|/hooks/use-mfe-module';
import styles from './chat-ui.module.css';

declare global {
  interface Window {
    CarvanaChatUiModule: {
      default: any;
    };
  }
}

const DD_ACTION = 'chat-ui-load';

function mfeCacheBuster() {
  const date = new Date();
  const nearestQuarterHour = Math.round(date.getMinutes() / 15) * 15;
  return `${date.getDate()}${date.getHours()}${nearestQuarterHour}`;
}

const ChatUi = () => {
  const isReady = useMfeModule(
    `${process.env.CHAT_BASE_URL}/build/assets-manifest.json?v=${mfeCacheBuster()}`,
    'main.js',
    'CarvanaChatUiModule',
    DD_ACTION
  );

  const { pathname } = useLocation();
  const { isSlateSkin } = useSlate();
  const { isCheckItOutTreatment } = useContext(CheckItOutContext);

  if (
    !isReady ||
    (pathname.startsWith('/steps/order-placed') && !isSlateSkin) ||
    (pathname.startsWith('/vehicle/') && !isSlateSkin)
  )
    return null;
  datadogRum.addAction(DD_ACTION, { type: 'render' });
  const ChatMfe = window.CarvanaChatUiModule.default;
  const chatMfe = <ChatMfe experience={isSlateSkin ? 'slate' : 'carvana'} />;

  // The shell only exists so checkout's sticky Continue bar can lift the chat bubble via
  // --pp-sticky-bar-height, and checkout is treatment-only. It relies on the chat MFE not
  // portaling to document.body, which a chat deploy could change — keep the control arm on
  // the bare MFE.
  if (!isCheckItOutTreatment) return chatMfe;

  return (
    <div className={styles.chatShell}>
      <div className={styles.chatShellContent}>{chatMfe}</div>
    </div>
  );
};

export default ChatUi;
